import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import type { IClient } from "src/services/ClientService";

// Retain the visible client during navigation, but never let an older response
// replace the destination. The page is keyed by project/user, not by client.
export function useClientPageData(clientId: number, projectId: number) {
	useLocale();
	const [state, setState] = useState<{ requestedId: number; client?: IClient; error?: IError; busy: boolean }>({ requestedId: clientId, busy: true });
	const [revision, setRevision] = useState(0);
	useEffect(() => {
		let cancelled = false;
		setState(previous => ({ requestedId: clientId, client: previous.client, busy: true }));
		void GD.REQ_API.request({ method: "clients/get", data: { id: clientId }, expectedProjectId: projectId }).then(response => {
			if (cancelled) return;
			if (response.error) throw response.error;
			if (response.data?.id !== clientId) throw new Error(msg("unexpectedClientResponse"));
			setState({ requestedId: clientId, client: response.data, busy: false });
		}).catch(failure => {
			if (!cancelled) setState({ requestedId: clientId, busy: false, error: {
				code: typeof failure?.code === "number" ? failure.code : -1,
				message: failure?.message || msg("unableToLoadClientPleaseTryAgain"),
			} });
		});
		return () => { cancelled = true; };
	}, [clientId, projectId, revision]);
	return {
		client: state.client,
		error: state.requestedId === clientId ? state.error : undefined,
		busy: state.requestedId !== clientId || state.busy,
		reload: () => setRevision(value => value + 1),
		update: (client: IClient) => setState(previous => previous.client?.id === client.id && client.id === clientId ? { ...previous, client } : previous),
	};
}
